export const GOOGLE_MAPS_API_KEY = 'AIzaSyD0CH7-cvnp8TfPYD_tSgoGv3SP2kCUWyQ'

/**
 * The Google cloud map style the maps render with.
 *
 * The default, `6e3ee63b529b2745e8e18dbd`, is a real Map ID for vectors. `VITE_GOOGLE_MAPS_MAP_ID`
 * overrides it for a deployment that wants different styling. A Map ID is not a secret: keep the
 * default here rather than moving it behind an env var.
 */
export const GOOGLE_MAPS_MAP_ID: string = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || '6e3ee63b529b2745e8e18dbd'

export const GRACE_PERIOD_FULL_ACCESS_DAYS = 2 // Initial grace period with full access
export const GRACE_PERIOD_TOTAL_DAYS = 10 // Total grace period with restricted access

export const FREE_PRICE_LABEL = 'Free'

export const PERIOD_ABBREVIATIONS = {
	month: 'month',
	year: 'year',
} as const

export const URL_CHARACTER_LIMIT = 8000

export const TIMESERIES_DOWNLOAD_LIMIT_BYTES = 1 * 1024 * 1024 * 1024 // 1GB limit for timeseries CSV/XLSX exports

export const TIMESERIES_DOWNLOAD_ROW_LIMIT = 5_000_000 // Max rows allowed before a timeseries-download is blocked

export const SESSIONS_EXPORT_ROW_LIMIT = 5_000_000 // Max rows allowed before a sessions export is blocked

export const METADATA_UPLOAD_SIZE_WARNING_BYTES = 1 * 1024 * 1024 * 1024 // 1GB warning threshold for metadata CSV uploads

export const validationPatterns = {
	email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
	phone: /^\+?[\d\s-()]+$/,
	name: /^[a-zA-Z\s]+$/,
	alphanumeric: /^[a-zA-Z0-9]+$/,
	integer: /^-?\d+$/,
	wholeNumber: /^\d+$/,
	float: /^-?\d*\.?\d+$/,
}

// ====================== Documentation Pages Id ======================
export const urlToDocId = {
	// ========================= Device Management ===============================
	devices: '/platform-guide/device-management/introduction-to-device-management',

	// ========================= Dashboard ===============================
	dashboards: '/platform-guide/dashboards/introduction-to-dashboards',

	// =========================  Actions ===============================
	actions: '/platform-guide/actions/action-details/introduction',
	'live-actions': '/platform-guide/actions/action-details/live-actions-list',
	inventory: '/platform-guide/actions/inventory-management/introduction',
	'firmware-files': '/platform-guide/actions/inventory-management/introduction',
	'json-configurations': '/platform-guide/actions/inventory-management/introduction',
	'geofence-configurations': '/platform-guide/actions/inventory-management/introduction',
	'new-action': '/platform-guide/actions/action-details/triggering-new-action',
	'action-settings': '/platform-guide/action-types/introduction-to-action-types',

	// ========================= Sessions ===============================
	alerts: '/platform-guide/alert-system/introduction-to-alerts-and-notifications',
	'session-rules': '/platform-guide/alert-system/introduction-to-alerts-and-notifications',
	'alert-rules': '/platform-guide/alert-system/introduction-to-alerts-and-notifications',
	'alert-notification': '/platform-guide/alert-system/introduction-to-alerts-and-notifications',

	// ========================= Settings ===============================
	general: '/platform-guide/general-settings',
	streams: '/platform-guide/streams-tables/introduction-to-streams',
	users: '/platform-guide/users/introduction-to-users-in-projects',
	roles: '/platform-guide/roles/role-based-access-control',
	metadata: '/platform-guide/metadata/introduction-to-metadata-keys',
	api_keys: '/platform-guide/api-keys/introduction-to-api-keys',
	session_types: '/platform-guide/session-types/introduction-to-session-types',
	dbc: '/platform-guide/dbc-parsers/introduction-to-dbc-parsers',
	device_components: '/platform-guide/device-components/introduction-to-device-components',
}
